import { HELP_PAGE, GAME_PAGE, START_PAGE } from '../const';

export const SET_SINGLE_APP = 'SET SINGLE APP';
export const SET_BEEN_HOME = 'BEEN HOME';
export const SELECT_APP = 'SELECT APP';
export const SET_USER_ID = 'SET USER ID';
export const SET_GLOBAL_OPTIONS = 'SET GLOBAL OPTIONS';
export const SET_GLOBAL_OPTION = 'SET GLOBAL OPTION';
export const SHOW_LEADERS = 'SHOW LEADERS';
export const OVER_RESTART = 'OVER RESTART';
export const GOTO_PAGE = 'GOTO PAGE';
export const GOTO_START_PAGE = { type: GOTO_PAGE, payload: { page: START_PAGE } };
export const GOTO_GAME_PAGE = { type: GOTO_PAGE, payload: { page: GAME_PAGE } };
export const GOTO_HELP_FROM_GAME_PAGE = { type: GOTO_PAGE, payload: { page: HELP_PAGE, fromPage: GAME_PAGE } };
export const REQUEST_RESET_STATS = 'REQUEST RESET STATS';
export const REQUEST_RESET_STATS_ON = { type: REQUEST_RESET_STATS, on: true };
export const REQUEST_RESET_STATS_OFF = { type: REQUEST_RESET_STATS, on: false };
export const REQUEST_SURRENDER = 'REQUEST SURRENDER';
export const REQUEST_SURRENDER_ON = { type: REQUEST_SURRENDER, on: true };
export const REQUEST_SURRENDER_OFF = { type: REQUEST_SURRENDER, on: false };
export const FORCE_UPDATE = 'FORCE UPDATE';
export const SHUFFLE_APPS = 'SHUFFLE APPS';
export const SET_RESTART = 'SET RESTART';
export const SET_RESTART_ON = { type: SET_RESTART, on: true };
export const SET_RESTART_OFF = { type: SET_RESTART, on: false };

export const selectApp = app => ({ type: SELECT_APP, app });
export const setUserId = uid => ({ type: SET_USER_ID, uid });
export const setGlobalOptions = options => ({ type: SET_GLOBAL_OPTIONS, options });
export const setGlobalOption = payload => ({ type: SET_GLOBAL_OPTION, payload });
export const showLeaderboards = op => ({ type: SHOW_LEADERS, op });
export const goToPage = (page, fromPage) => ({ type: GOTO_PAGE, payload: { page, fromPage } });
export const requestResetStats = on => ({ type: REQUEST_RESET_STATS, on });
export const requestSurrender = on => ({ type: REQUEST_SURRENDER, on });
export const setRestart = on => ({ type: SET_RESTART, on });
export const forceUpdate = () => ({ type: FORCE_UPDATE });
